import Resolver from "@/api/resolver";
import {
  dateDiffHumanReadable,
  localNow,
  parseServerTime
} from "@/filters/DateAndTime";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { userNamespace } from "@/store/modules/user";
import { User } from "@/store/modules/user/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Colors } from "../components/shared/util";

@Component({
  components: {}
})
export default class NavMenu extends Vue {
  @Action("resetAll")
  resetAll!: Function;

  @Action("setArea", userNamespace)
  setArea!: Function;

  @Action("goHome", navigationNamespace)
  goHome!: Function;

  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("singlePatientView", patientNamespace)
  singlePatientView!: boolean;

  @Getter("inWrapper", navigationNamespace)
  inWrapper!: boolean;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("isMobile", navigationNamespace)
  isMobile!: boolean;

  @Getter("darkMode", navigationNamespace)
  darkMode!: boolean;

  @Getter("areas", userNamespace)
  areas!: Array<string>;

  @Getter("fullName", userNamespace)
  fullName!: string;

  @Getter("sessionStart", userNamespace)
  sessionStart!: string;

  @Getter("ipAddr", userNamespace)
  ipAddr!: string;

  @Getter("computer", userNamespace)
  computer!: string;

  @Getter("user", userNamespace)
  user!: User;

  @Action("logout", userNamespace)
  actionLogout!: Function;

  @Getter("isTesting", patientNamespace)
  isTesting!: boolean;

  @Getter("isPagingTest", patientNamespace)
  isPagingTest!: boolean;

  @Getter("isActiveTest", patientNamespace)
  isActiveTest!: boolean;

  @Getter("now", patientNamespace)
  now: any;

  @Prop({
    default: () => {
      return true;
    }
  })
  showSwitchProducts!: boolean;

  showHelp!: boolean;

  get colorGreen() {
    return "#32cd32";
  }

  get isAdmin() {
    return this.user.isAdmin === true;
  }

  get StatusGreen() {
    return Colors.TestGreen;
  }

  get sessionStartDisplay() {
    const start = parseServerTime(this.sessionStart);
    const adjust =
      Resolver.dateTimeOffset == "+00:00"
        ? start.add(-1 * start.utcOffset(), "minute")
        : start;
    const nowYear = localNow().format("YYYY");
    return (
      adjust.format("MMM D") +
      (adjust.format("YYYY") != nowYear ? ", " + adjust.format("YYYY") : "") +
      " @ " +
      adjust.format("h:mm a")
    );
  }

  get hasArea() {
    return this.area != undefined;
  }

  get showStatusLink() {
    const show = !this.$route.path.startsWith("/status");
    return show;
  }

  get sessionAgeDisplay() {
    return dateDiffHumanReadable(this.sessionStart, this.now).replace(".0", "");
  }

  get computerDisplay() {
    return this.computer !== "unknown" ? this.computer.split(".")[0] : "";
  }

  async logout() {
    await this.actionLogout();
    this.resetAll();
    this.$router.replace({ path: "/login" });
  }

  async status() {
    this.setArea("");
    this.$router.push({ path: "/status" });
  }

  get multipleAreas() {
    return this.areas && this.areas.length > 1;
  }

  switchProduct() {
    this.setArea("");
    this.$router.push({ path: "/productSelect" });
  }
}
